import React from "react";
import ReactDOM from "react-dom";
import './css/Header.scss';

export function Header() {
  return (
      <div className="top-nav">
        <a href="index.html" className="link scramble-hover">C. K. Bilstad</a>
        <a href="fragments.html" className="link">Bits & Pieces</a>
        <a data-bs-toggle="modal" data-bs-target="#aboutmodal" className="link">About</a>
        <a href="#" className="scramble-hover">Les mer</a>

      </div>
  );
}


const app = document.getElementById("header");
ReactDOM.render(<Header />, header);